import { useEffect } from "react";
import { useSelector } from "react-redux";

import appSelectors from "redux/app/appSelectors";

const useTheme = () => {
  const theme = useSelector(appSelectors.theme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('vps24-theme', theme);
  }, [theme]);

}

export default useTheme